import { render, staticRenderFns } from "./weixinbidsdes.vue?vue&type=template&id=04721eaa&"
import script from "./weixinbidsdes.vue?vue&type=script&lang=js&"
export * from "./weixinbidsdes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports